import api from '@/api'

const state = {

}

const mutations = {

}

const actions = {
  listPriceAdjustByCondWithPage ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.listPriceAdjustByCondWithPage(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/listPriceAdjustByCondWithPage', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/pOrderAdjust/listPriceAdjustByCondWithPage', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  confirmPriceAdjust ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.confirmPriceAdjust(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/confirmPriceAdjust', error: resData.error })
      }
    }
  }).catch(e => {
      reject({ from: '/sweb/pOrderAdjust/confirmPriceAdjust', error: {code: 0, msg: '网络异常，请稍后再试'} })
    })
  })
  },
  getPriceAdjustRule ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.getPriceAdjustRule(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/getPriceAdjustRule', error: resData.error })
      }
    }
  }).catch(e => {
      reject({ from: '/sweb/pOrderAdjust/getPriceAdjustRule', error: {code: 0, msg: '网络异常，请稍后再试'} })
    })
  })
  },
  mapListInstockOrder ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListInstockOrder(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/mapListInstockOrder', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/pOrderAdjust/mapListInstockOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  mapListReturnOrder ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListReturnOrder(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/mapListReturnOrder', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/pOrderAdjust/mapListReturnOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  mapListAdjustInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListAdjustInfo(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/pOrderAdjust/mapListReturnOrder', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/pOrderAdjust/mapListReturnOrder', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  mapListReturnInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListReturnInfo(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierReturn/mapListReturnInfo', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierReturn/mapListReturnInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  mapListFineInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.mapListFineInfo(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierFine/mapListFineInfo', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierFine/mapListFineInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // mapListInfo ({ commit, dispatch }, data) {
  //   return new Promise((resolve, reject) => {
  //     api.mapListInfo(data).then(res => {
  //     let resData = res.data
  //     if (resData.ret === 1 && resData.data) {
  //     resolve(resData)
  //   } else {
  //     if (resData.error) {
  //       reject({ from: '/sweb/supplierChargeReceipts/mapListInfo', error: resData.error })
  //     }
  //   }
  // }).catch(e => {
  //     reject({from: '/sweb/supplierChargeReceipts/mapListInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //   })
  // })
  // },
  applyTicket ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.applyTicket(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/applyTicket', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/applyTicket', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  chargeType ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.chargeType(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/chargeType', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/chargeType', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  paymentType ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.paymentType(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/paymentType', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/paymentType', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  debitStatus ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.debitStatus(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/debitStatus', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/debitStatus', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  invoiceStatus ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.invoiceStatus(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoiceStatus', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoiceStatus', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  lastInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.lastInvoice(data).then(res => {
      let resData = res.data
      if (resData.ret === 1) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/getLastInvoice', error: resData.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoiceStatus', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 竞对毛补相关接口
  // 竟对毛补查询列表
  // getCompensateList ({ commit, dispatch }, data) {
  //   return new Promise((resolve, reject) => {
  //     api.getCompensateList(data).then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1) {
  //         resolve(resData.data)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/mapListInfo', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/mapListInfo,', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  // 获取罚单状态列表
  // getCompensateStatus ({ commit, dispatch }) {
  //   return new Promise((resolve, reject) => {
  //     api.getCompensateStatus().then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1 && resData.data) {
  //         resolve(resData)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/getStatusList', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/getStatusList', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  // 获取支付方式列表
  // getChargeTypeList ({ commit, dispatch }) {
  //   return new Promise((resolve, reject) => {
  //     api.getChargeTypeList().then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1 && resData.data) {
  //         resolve(resData)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/getChargeList', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/getChargeList', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  // 根据单据编号获取详细数据
  // getCompensateDetailList ({ commit, dispatch }, data) {
  //   return new Promise((resolve, reject) => {
  //     api.getCompensateDetailList(data).then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1 && resData.data) {
  //         resolve(resData)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/getDetailInfoPage', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/getDetailInfoPage,', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  // 确认竞对毛补单
  // confirmCompensateOrder ({ commit, dispatch }, data) {
  //   return new Promise((resolve, reject) => {
  //     api.confirmCompensateOrder(data).then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1 && resData.data) {
  //         resolve(resData)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/confirm', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/confirm,', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  // 申诉竞对毛补单
  // rejectCompensateOrder ({ commit, dispatch }, data) {
  //   return new Promise((resolve, reject) => {
  //     api.rejectCompensateOrder(data).then(res => {
  //       let resData = res.data
  //       if (resData.ret === 1 && resData.data) {
  //         resolve(resData)
  //       } else {
  //         if (resData.error) {
  //           reject({ from: '/sweb/subSidy/reject', error: resData.error.msg })
  //         }
  //       }
  //     }).catch(e => {
  //       reject({from: '/sweb/subSidy/reject,', error: {code: 0, msg: '网络异常，请稍后再试'}})
  //     })
  //   })
  // },
  /** 合同内费用开单 */
  // 首页列表
  selectContractBills ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.selectContractBills(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/selectContractBills', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/selectContractBills,', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 可开票数据
  selectTicketBills ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.selectTicketBills(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/selectTicketBills', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/selectTicketBills,', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票数据校验
  invoiceVerify ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.invoiceVerify(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData.data)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoiceVerify', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoiceVerify,', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 省市区列表
  selectCityInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.selectCityInfo(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/selectCityInfo', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/selectCityInfo,', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票
  applyInvoice ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.applyInvoice(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/applyInvoice', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/applyInvoice,', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票详情
  invoiceDetail ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.invoiceDetail(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoiceDetail', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoiceDetail', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票计划集合
  queryInvoicePlan ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryInvoicePlan(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/queryPlan', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoice/queryPlan', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票计划明细集合
  queryInvoicePlanItem ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryInvoicePlanItem(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/queryPlanItem', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoice/queryPlanItem', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票计划明细集合
  queryInvoiceInfo ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.queryInvoiceInfo(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/queryInfo', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoice/queryInfo', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 开票计划明细集合
  applyInvalidInvoicePlan ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.applyInvalidInvoicePlan(data).then(res => {
      let resData = res.data
      if (resData.ret === 1 && resData.data) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/applyInvalidPlan', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoice/applyInvalidPlan', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  },
  // 修改发票抬头信息
  modifyInvoiceTitle ({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.modifyInvoiceTitle(data).then(res => {
      let resData = res.data

      if (resData.ret === 1) {
      resolve(resData)
    } else {
      if (resData.error) {
        reject({ from: '/sweb/supplierChargeReceipts/invoice/modifyInvoiceTitle', error: resData.error.error })
      }
    }
  }).catch(e => {
      reject({from: '/sweb/supplierChargeReceipts/invoice/modifyInvoiceTitle', error: {code: 0, msg: '网络异常，请稍后再试'}})
    })
  })
  }

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/adjustOrder.js